import { __assign } from "tslib";
import React, { createRef, useState } from 'react';
import cn from 'classnames';
import ExternalToolbar from '../ExternalToolbar/ExternalToolbar';
import PlusIcon from '@wix/da-ds/pkg/Icons/Plus';
import IconButton from '../../../Button/IconButton';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { useOnOutsideClick } from '../../../utils/hooks/useOnOutsideClick';
import s from './SideToolbar.scss';
var SideToolbar = function (_a) {
    var className = _a.className, style = _a.style, toolbarProps = _a.toolbarProps;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var wrapperRef = createRef();
    useOnOutsideClick(wrapperRef, function () {
        setIsOpen(false);
    });
    if (style.top) {
        style = __assign(__assign({}, style), { top: style.top - 4 });
    }
    return (React.createElement("div", { ref: wrapperRef, className: cn(s['root'], className), style: style },
        React.createElement(IconButton, { className: cn(s['plus'], isOpen && s['plus-active']), onClick: function () { return setIsOpen(!isOpen); } },
            React.createElement(PlusIcon, { size: IconSize.SMALL })),
        React.createElement("div", { className: cn(s['toolbar-container'], isOpen && s['open']) }, isOpen && (React.createElement(ExternalToolbar, __assign({}, toolbarProps, { onPluginClick: function () { return setIsOpen(false); } }))))));
};
SideToolbar.displayName = 'SideToolbar';
export default SideToolbar;
//# sourceMappingURL=SideToolbar.js.map